/**
 * Sort array of values by string values with respect to numbers inside it.
 * Ignore punctuation.
 *
 * Returns new array sorted. Doesn't modify incoming array.
 */
export const sortWithNumericRespect = <T>(
	data: T[],
	valueRetriever: (item: T) => string,
): T[] => {
	return [...data].sort((a, b) =>
		new Intl.Collator('en', { numeric: true, ignorePunctuation: true }).compare(
			valueRetriever(a),
			valueRetriever(b),
		),
	);
};
